import { isEmpty, map, sortBy } from 'lodash';
import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { compose } from 'redux';
import { connect } from 'react-redux';

import { ConfigsService as GeneralConfigService } from '@sm360/widget-commons-core-services';

import MetaDataModel from 'inventory-listing/models/MetaDataModel.js';
import VehicleCriteriaModel from 'inventory-listing/models/VehicleCriteriaModel';

const QUERY_USED = gql`
    query fetchUsedModelsMetadata($organizationUnitId: Int!, $vehicleCriteria: VehicleCriteria) {
        searchVehicles(first: 1, organizationUnitId: $organizationUnitId, vehicleCriteria: $vehicleCriteria) {
            metadataCategories(include: [MODEL]) {
                name
                metadatas {
                    code
                    label
                }
            }
        }
    }
`;

const QUERY_NEW = gql`
    query fetchNewModelsMetadata($organizationUnitId: Int!, $newVehicleCriteria: NewVehicleCriteria) {
        searchNewVehicles(first: 1, organizationUnitId: $organizationUnitId, newVehicleCriteria: $newVehicleCriteria) {
            metadataCategories(include: [MODEL]) {
                name
                metadatas {
                    code
                    label
                }
            }
        }
    }
`;

function buildModels(data) {
    const { metadataCategories } = data;
    if (isEmpty(metadataCategories)) {
        return [];
    }
    return sortBy(
        map(metadataCategories[0].metadatas, (metadata) => {
            let url;
            if (!metadata.url || isEmpty(metadata.url)) {
                url = metadata.label.toLowerCase().replace(/ /g, '-');
            }
            return new MetaDataModel({ ...metadata, url });
        }),
        ['label']
    );
}

function mapPropsToOptions({ isListingNew, makeCode, vehicleCriteria }) {
    const criteria = vehicleCriteria || new VehicleCriteriaModel();

    const variables = {
        organizationUnitId: GeneralConfigService.getOrganizationUnitId(),
        [isListingNew ? 'newVehicleCriteria' : 'vehicleCriteria']: {
            ...criteria.mapToLimitedMandatoryPropertySetObject(),
            onlyBuiltVehicles: isListingNew ? criteria.onlyBuiltVehicles : false,
            makeIds: [makeCode],
        },
    };

    return { variables };
}

function mapDataToProps(props) {
    const { data } = props;
    let models = [];

    // one pass for used
    if (data && data.searchVehicles) {
        const { loading, searchVehicles } = data;

        if (!loading && searchVehicles) {
            models = buildModels(searchVehicles);
        }
    }

    // one pass for new
    if (data && data.searchNewVehicles) {
        const { loading, searchNewVehicles } = data;

        if (!loading && searchNewVehicles) {
            models = buildModels(searchNewVehicles);
        }
    }

    return {
        models,
    };
}

const modelsForListingUsed = graphql(QUERY_USED, {
    alias: 'modelsForListingUsed',
    options: mapPropsToOptions,
    props: mapDataToProps,
    skip: (props) => props.isListingNew || !props.isMakeSelected,
});

const modelsForListingNew = graphql(QUERY_NEW, {
    alias: 'modelsForListingNew',
    options: mapPropsToOptions,
    props: mapDataToProps,
    skip: (props) => !props.isListingNew || !props.isMakeSelected,
});

function mapStateToProps(state) {
    return {
        vehicleCriteria: state.listingUsed.vehicleCriteria,
        isListingNew: state.listingUsed.colanderGroupIsNew(),
    };
}

const reduxContainer = connect(
    mapStateToProps,
    null
);

export default compose(
    reduxContainer,
    modelsForListingNew,
    modelsForListingUsed
);



// WEBPACK FOOTER //
// ./client/src/components/ListingFilters/Components/ListingFiltersBrand/ModelsContainer.js